/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateOktaVerificationKeyInput = {|
  email?: ?string,
  issuer?: ?string,
  clientMutationId?: ?string,
|};
export type createOktaVerificationKeyMutationVariables = {|
  input: CreateOktaVerificationKeyInput
|};
export type createOktaVerificationKeyMutationResponse = {|
  +createOktaVerificationKey: ?{|
    +key: ?string,
    +oktaClientId: ?string,
    +oktaUrl: ?string,
  |}
|};
export type createOktaVerificationKeyMutation = {|
  variables: createOktaVerificationKeyMutationVariables,
  response: createOktaVerificationKeyMutationResponse,
|};
*/


/*
mutation createOktaVerificationKeyMutation(
  $input: CreateOktaVerificationKeyInput!
) {
  createOktaVerificationKey(input: $input) {
    key
    oktaClientId
    oktaUrl
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateOktaVerificationKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateOktaVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createOktaVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oktaClientId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oktaUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createOktaVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createOktaVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createOktaVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createOktaVerificationKeyMutation(\n  $input: CreateOktaVerificationKeyInput!\n) {\n  createOktaVerificationKey(input: $input) {\n    key\n    oktaClientId\n    oktaUrl\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2167be95e7dfd72710e98f0bdbe4742b';

module.exports = node;
